"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 10 11';

var Delete = function Delete() {
  return _react["default"].createElement("path", {
    d: "M9.616,9.327 L5.6755,5.387 L9.6105,1.452 C9.8285,1.234 9.8285,0.881 9.6105,0.6635 C9.393,0.4455 9.04,0.4455 8.822,0.6635 L4.887,4.5985 L0.952,0.6635 C0.734,0.4455 0.381,0.4455 0.1635,0.6635 C-0.0545,0.881 -0.0545,1.234 0.1635,1.452 L4.0985,5.387 L0.1635,9.322 C-0.0545,9.54 -0.0545,9.893 0.1635,10.1105 C0.272,10.2195 0.4155,10.2745 0.558,10.2745 C0.7005,10.2745 0.843,10.2195 0.952,10.1105 L4.887,6.1755 L8.8275,10.1155 C8.9365,10.2245 9.079,10.279 9.2215,10.279 C9.364,10.279 9.5065,10.2245 9.616,10.1155 C9.834,9.898 9.834,9.545 9.616,9.327"
  });
};

var _default = (0, _createSvgIcon["default"])(Delete, {
  viewBox: viewBox
});

exports["default"] = _default;